















































































import { Component, Vue, Prop } from 'vue-property-decorator';
import Topbar from '@/components/Topbar.vue';
import Carousel from '@/components/Carousel.vue';
import SearchStore from '@/store/SearchStore';
import { GoogleMapsService } from '@/services/GoogleMaps';
import { Search } from '../models/Search';

@Component({
  components: {
    Topbar,
    Carousel,
  },
})
export default class SearchBar extends Vue {
  public returnRoute: string = 'home';
  public query: string = '';
  public predictions: any[] = [];
  public gapiReady: boolean = false;
  public loading: boolean = false;
  public apiError: any = null;
  @Prop({ default: '' }) public size!: string;

  public listener: any = null;

  public refs!: {
    searchbar: HTMLElement;
  };

  public expanded: boolean = false;

  public mounted() {
    this.returnRoute = this.$route.params.returnRoute || 'home';

    GoogleMapsService.loadGoogleApi().then(async () => {
      this.gapiReady = true;
    });
  }

  public close() {
    this.$router.push({ name: this.returnRoute });
  }

  public expand() {
    this.expanded = true;

    setTimeout(() => {
      this.listener = window.addEventListener('click', (e: any) => {
        if (!(this.$refs.searchbar as HTMLElement).contains(e.target)) {
          this.collapse();
        }
      });
    }, 0);
  }

  public collapse() {
    this.expanded = false;

    window.removeEventListener('click', this.listener);
  }

  public async getPredictions() {
    this.predictions = await GoogleMapsService.getPredictions(this.query);
  }

  public async selectLocation(prediction: any) {
    const geoDetails = await GoogleMapsService.geocode(prediction.description);

    const search = new Search(geoDetails);

    SearchStore.Search(geoDetails);

    this.$router.push({
      name: 'search-results',
      params: {
        query: encodeURI(geoDetails.query),
      },
    });
  }
}
